exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".font.primary {\n  font-family: \"Raleway\", sans-serif;\n  color: #eee;\n  line-height: 1.8; }\n\n.font.secondary {\n  font-family: \"Montserrat\", sans-serif;\n  color: #aaa;\n  line-height: 1.8; }\n\n.font.description {\n  font-family: \"Montserrat\", sans-serif;\n  color: #aaa;\n  font-size: 20px;\n  line-height: 1.8; }\n\n.font.w300 {\n  font-weight: 300; }\n\n.font.bold {\n  font-weight: bold; }\n\n.font.s-50 {\n  font-size: 50px; }\n\n.font.s-40 {\n  font-size: 40px; }\n\n.font.s-30 {\n  font-size: 30px; }\n\n.font.s-25 {\n  font-size: 25px; }\n\n.font.s-20 {\n  font-size: 20px; }\n\n.font.s-15 {\n  font-size: 15px; }\n\n.font.l-1 {\n  line-height: 1; }\n\n.font.l-14 {\n  line-height: 1.4; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/layout/Font/index.scss
// module id = 637
// module chunks = 0